import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroListaProcessoRevisaoClienteFornecedor {
  lastSetDefault: Date;

  dInclusao_de: Date;
  dInclusao_ate: Date;
  cStatus: string;
  cCGC: string;
  nCodigo: number | null;
  cTipo: string;
  cTipoINN: string;
  cUsuario: string;

}

export class FiltroListaProcessoRevisaoClienteFornecedor {

  dados: IFiltroListaProcessoRevisaoClienteFornecedor;
  storageName: string;

  constructor(private poStorageService: PoStorageService, storageName: string = 'filtro-lista-processo-cadastro') {

    this.dados = this.setDefault();
    this.storageName = storageName;

    this.poStorageService.get(this.storageName).then((filtro: IFiltroListaProcessoRevisaoClienteFornecedor) => {
      if (filtro) {
        const {
          lastSetDefault,
          dInclusao_de,
          dInclusao_ate,
          cTipoINN} = filtro;


        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: lastSetDefault,
            dInclusao_de: new Date(dInclusao_de),
            dInclusao_ate: new Date(dInclusao_ate),
            cTipoINN: cTipoINN?.length ? cTipoINN : cTipoINN.toString(),
          }
        }
      }
    });
  }

  public setDefault = (): IFiltroListaProcessoRevisaoClienteFornecedor => {
    return {
      lastSetDefault: new Date(),
      dInclusao_de: this.getData(-90),
      dInclusao_ate: new Date(),
      cStatus: '',
      cCGC: '',
      nCodigo: null,
      cTipo: '',
      cTipoINN: 'K,W',
      cUsuario: '',
    }
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const data = new Date();
    data.setDate(data.getDate() + dias);
    return data;
  }

}
